export const getRowLength = element => {
  return parseInt(
    window.innerWidth / element.getBoundingClientRect().width,
    10,
  );
};
